// extracted by mini-css-extract-plugin
export var addButton = "_5t-d";
export var bullets = "_5t-e";
export var compact = "_5t-2";
export var container = "_5t-j";
export var extendedWarrantyModal = "_5t-f";
export var learn = "_5t-l";
export var learnMore = "_5t-g";
export var offeringOption = "_5t-3";
export var offeringPrice = "_5t-8";
export var offeringSubtitle = "_5t-7";
export var offeringTitle = "_5t-6";
export var offeringsContainer = "_5t-0";
export var pdpTilesBackground = "_5t-n";
export var plan = "_5t-m";
export var regular = "_5t-1";
export var remove = "_5t-k";
export var seeDetailsIcon = "_5t-i";
export var seeDetailsLink = "_5t-h";
export var selectedOption = "_5t-4";
export var shieldIcon = "_5t-b";
export var shieldIconCompact = "_5t-c";
export var subtitle = "_5t-a";
export var title = "_5t-9";
export var unselectedOption = "_5t-5";